// extracted by mini-css-extract-plugin
export default {"container":"DetailsContainer_container__vfEfZ"};